module.exports = __webpack_public_path__ + "img/questionmark-avatar.57477737.jpg";